import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { enrollmentAPI } from '../../services/api';
import { LoadingSpinner, EmptyState } from '../../components/UI';

const AdminEnrollments = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [tab, setTab] = useState('pending');
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await enrollmentAPI.all();
      setEnrollments(data);
    } catch (e) {
      toast.error('Failed to load enrollments');
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, []);

  const handleStatus = async (id, status) => {
    try {
      await enrollmentAPI.updateStatus(id, status);
      toast.success(`Enrollment ${status}`);
      fetchData();
    } catch (e) {
      toast.error('Update failed');
    }
  };

  const filtered = tab === 'all' ? enrollments : enrollments.filter((e) => e.status === tab);

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1>Enrollments</h1>
          <p className="subtitle">Approve or reject student enrollment requests</p>
        </div>
      </div>

      <div className="tabs">
        {['pending', 'approved', 'completed', 'rejected', 'all'].map((t) => (
          <button key={t} className={`tab ${tab === t ? 'active' : ''}`} onClick={() => setTab(t)}>
            {t.charAt(0).toUpperCase() + t.slice(1)} ({t === 'all' ? enrollments.length : enrollments.filter((e) => e.status === t).length})
          </button>
        ))}
      </div>

      {loading ? <LoadingSpinner /> : filtered.length === 0 ? (
        <EmptyState icon="📋" title="No enrollments" message={`No ${tab} enrollments found`} />
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Course</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Enrolled</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((e) => (
                <tr key={e._id}>
                  <td>
                    <strong>{e.user?.name}</strong>
                    <div className="text-muted" style={{ fontSize: '0.8rem' }}>{e.user?.email}</div>
                  </td>
                  <td>{e.course?.title}</td>
                  <td><span className={`badge badge-${e.status}`}>{e.status}</span></td>
                  <td>
                    <div style={{ minWidth: 120 }}>
                      <div className="progress"><div className="progress-bar" style={{ width: `${e.progress}%` }}></div></div>
                      <small className="text-muted">{e.progress}%</small>
                    </div>
                  </td>
                  <td>{new Date(e.createdAt).toLocaleDateString()}</td>
                  <td>
                    {e.status === 'pending' && (
                      <div className="flex gap-1">
                        <button className="btn btn-success btn-sm" onClick={() => handleStatus(e._id, 'approved')}>Approve</button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleStatus(e._id, 'rejected')}>Reject</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminEnrollments;
